<template>
  <MainWrapper>
    <div class="single-master-page">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="container-fluid no-p">
              <div class="row">
                <div class="col-lg-12">
                  <h2 class="mb-15">Результаты поиска: {{ $route.params.search_slug }}</h2>
                </div>
              </div>
              <div class="row">
                <Button :text="'Специалисты ('+specCount+')'" icon="" @click="tab = 'spec';page = 1" />
                <Button class="ml-15" :text="'Учреждения ('+orgCount+')'" icon="" @click="tab = 'org';page = 1" />
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="mb-30">
                    <Paginator :pages='pages' v-if="pages > 1" :current='page' v-on:change-page="(p) => page = p" />
                  </div>
                </div>
              </div>
              <div v-if="tab === 'spec'" class="row">
                <div class="col-lg-4" v-for="spec in specialists" :key="spec.id">
                  <Specialist :name="spec.full_name"
                              :rating="spec.rating"
                              :cats="spec.categories"
                              :state="false"
                              :address="'г. Бишкек'"
                              :img="spec.photo"
                              :slug="spec.slug"
                              :status="spec.opened_now"
                              :reviewCount="spec.feeds_count"
                  />
                </div>
              </div>
              <div v-if="tab === 'org'" class="row">
                <div class="col-lg-4" v-for="company in companies" :key="company.id">
                  <Company :name="company.name"
                           :rating="company.rating"
                           :cats="company.categories"
                           :desc="company.short_info"
                           :state="false"
                           :address="'г. Бишкек'"
                           :img="company.photo"
                           :slug="company.slug"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <Paginator :pages='pages' v-if="pages > 1" :current='page' v-on:change-page="(p) => page = p" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </MainWrapper>
</template>
<script>
    import { Component, Vue, Watch } from "vue-property-decorator";
    import MainWrapper from '@/wrappers/MainWrapper.vue';
    import Button from '@/components/Button.vue';
    import Company from '@/components/Company.vue';
    import Specialist from '@/components/Specialist.vue';
    import Paginator from '@/components/Paginator.vue';
    import http from '@/methods/http.ts';

    @Component({
        components: {
            MainWrapper,
            Button,
            Company,
            Specialist,
            Paginator
        }
    })
    export default class Search extends Vue {

        tab = 'spec';

        companies = [];
        specialists = [];

        page = 1;
        pages = 0;
        specCount = 0;
        orgCount = 0;

        @Watch('$route', {deep: true, immediate: true})
        onRouteChange() {
            this.page = 1;
            if (this.tab === 'spec') {
                this.getSpecialists();
            }
            if (this.tab === 'org') {
                this.getCompanies();
            }
        }

        @Watch('page', {deep: true, immediate: true})
        onPageChange() {
            if (this.tab === 'spec') {
                this.getSpecialists();
            }
            if (this.tab === 'org') {
                this.getCompanies();
            }
        }

        @Watch('tab', {deep: true, immediate: true})
        onTabChange() {
            if (this.tab === 'spec') {
                this.getSpecialists();
            }
            if (this.tab === 'org') {
                this.getCompanies();
            }
        }

        getSpecialists() {
            http("search/specialists", "get", false, {
                page: this.page,
                page_size: 12,
                q: this.$route.params.search_slug
            }).then(
                r => {
                    this.specialists = r.data.results;
                    this.pages = Math.ceil(r.data.count / 12);
                    this.specCount = r.data.count;
                }
            );
        }

        getCompanies() {
            http("search/companies", "get", false, {
                page: this.page,
                page_size: 12,
                q: this.$route.params.search_slug
            }).then(
                r => {
                    this.companies = r.data.results;
                    this.pages = Math.ceil(r.data.count / 12);
                    this.orgCount = r.data.count;
                }
            );
        }

        mounted() {
            this.getSpecialists();
            this.getCompanies();
        }
    }
</script>
